    
const KLAVIYO_PUBLIC_KEY = 'YxZeT5';
const LIST_ID = "URj9Dt";
// ============ DATA ============
const FLOORING_TYPES = [
    { id:'rubber_roll', name:'Rubber Rolls', icon:'🏋️', price:30.00, desc:'Best for free weights & heavy lifting', thickness:'8mm–12mm' },
    { id:'rubber_tile', name:'Rubber Tiles', icon:'🔲', price:23.00, desc:'Interlocking, easy to replace', thickness:'15mm–20mm' },
    { id:'turf', name:'Artificial Turf', icon:'🌿', price:35.00, desc:'Sled pushes, agility, functional', thickness:'20mm–40mm' },
    { id:'foam', name:'Foam / Martial Arts', icon:'🥋', price:25.00, desc:'Classes, stretching, MMA', thickness:'20mm–40mm' },
    { id:'vinyl', name:'Commercial Vinyl', icon:'✨', price:32.00, desc:'Reception, cardio, locker rooms', thickness:'2mm–5mm' },
];

const EQUIPMENT_CATEGORIES = [
    { id:'cardio', name:'Cardio Machines', items:[
        { name:'Treadmills', qty:6, budget:1500, mid:3500, premium:8000 },
        { name:'Bikes (Upright/Spin)', qty:6, budget:500, mid:1500, premium:3500 },
        { name:'Rowing Machines', qty:3, budget:500, mid:1200, premium:3000 },
        { name:'Ellipticals / Cross-Trainers', qty:3, budget:600, mid:2000, premium:4500 },
    ]},
    { id:'strength', name:'Strength Equipment', items:[
        { name:'Power Racks / Squat Racks', qty:3, budget:500, mid:1500, premium:3500 },
        { name:'Flat/Adjustable Benches', qty:4, budget:200, mid:500, premium:1000 },
        { name:'Cable Machines', qty:2, budget:1000, mid:3000, premium:5500 },
        { name:'Plate-Loaded Machines', qty:3, budget:700, mid:1800, premium:4000 },
        { name:'Dumbbells (Set)', qty:1, budget:2000, mid:4000, premium:8000 },
        { name:'Barbells & Plates', qty:1, budget:1200, mid:3000, premium:7000 },
    ]},
    { id:'functional', name:'Functional / Accessories', items:[
        { name:'Kettlebells (Set)', qty:1, budget:400, mid:900, premium:1800 },
        { name:'Battle Ropes, Balls, Bands', qty:1, budget:350, mid:800, premium:1500 },
        { name:'Rig / Pull-Up Station', qty:1, budget:600, mid:2500, premium:5500 },
        { name:'Plyo Boxes & Mats', qty:1, budget:250, mid:700, premium:1400 },
    ]},
];

const OTHER_COSTS = [
    { id:'lease', name:'Lease Deposit (3 months)', multipliers:{ low:50, mid:100, high:150 }, unit:'per m²/yr', calcType:'lease' },
    { id:'buildout', name:'Buildout & Construction', multipliers:{ shell:130, former:45 }, unit:'per m²', calcType:'buildout' },
    { id:'hvac', name:'HVAC & Ventilation', base:6000, perSqft:15, calcType:'perSqft' },
    { id:'electrical', name:'Electrical & Lighting', base:3500, perSqft:12, calcType:'perSqft' },
    { id:'plumbing', name:'Plumbing (Showers/Toilets)', flat:{ low:5000, mid:10000, high:16000 }, calcType:'flat' },
    { id:'tech', name:'Technology (POS, Access, Sound)', flat:{ low:3000, mid:6000, high:10000 }, calcType:'flat' },
    { id:'signage', name:'Signage & Branding', flat:{ low:1000, mid:3000, high:5000 }, calcType:'flat' },
    { id:'permits', name:'Permits & Licensing', flat:{ low:500, mid:1500, high:3000 }, calcType:'flat' },
    { id:'insurance', name:'Insurance (First Year)', flat:{ low:1500, mid:3000, high:5000 }, calcType:'flat' },
    { id:'marketing', name:'Pre-Launch Marketing', flat:{ low:2000, mid:5000, high:10000 }, calcType:'flat' },
    { id:'working', name:'Working Capital (3 months)', multipliers:{ low:8000, mid:15000, high:25000 }, calcType:'workingCap' },
    { id:'contingency', name:'Contingency (10%)', calcType:'contingency' },
];

// ============ STATE ============
let currentStep = 1;
let zones = [];
let zonesEdited = false;
let equipQtys = {};
let otherOverrides = {};
let budgetChart = null;
let projectionChart = null;
let gateUnlocked = false;

// ============ INIT ============
function init() {
    renderFlooringTypes();
    addDefaultZones();
    renderEquipment();
    renderOtherCosts();
    recalc();
}

// ============ NAVIGATION ============
function goToStep(n) {
    currentStep = n;
    document.querySelectorAll('.section').forEach((s,i) => s.classList.toggle('active', i+1===n));
    document.querySelectorAll('.step-pill').forEach((p,i) => {
        p.classList.remove('active','done');
        if(i+1 === n) p.classList.add('active');
        else if(i+1 < n) p.classList.add('done');
    });
    if(n === 2) {
        // If zones haven't been manually edited yet (still defaults), refresh to match Step 1 total
        if(!zonesEdited) addDefaultZones();
        else updateZoneAllocation();
    }
    if(n === 5) {
        renderSummary();
        // Keep gate unlocked if already unlocked
        if(gateUnlocked) document.getElementById('gateWrapper').classList.remove('locked');
    }
    window.scrollTo({top:0, behavior:'smooth'});
}

// ============ STEP 1 ============
function updateSqftDisplay() {
    document.getElementById('sqftDisplay').textContent = parseInt(document.getElementById('totalSqft').value).toLocaleString();
    recalc();
}

// ============ STEP 2: FLOORING ============
function renderFlooringTypes() {
    const container = document.getElementById('flooringTypes');
    container.innerHTML = FLOORING_TYPES.map(f => `
        <div class="floor-type-card" id="ft-${f.id}" onclick="toggleFloorInfo('${f.id}')">
            <div class="icon">${f.icon}</div>
            <div class="name">${f.name}</div>
            <div class="price">£${f.price.toFixed(2)}/m²</div>
            <div class="desc">${f.desc}</div>
        </div>
    `).join('');
}

function toggleFloorInfo(id) {
    document.querySelectorAll('.floor-type-card').forEach(c => c.classList.remove('selected'));
    document.getElementById('ft-'+id).classList.add('selected');
}

function addDefaultZones() {
    const type = document.getElementById('gymType')?.value || 'general';
    const sqft = parseInt(document.getElementById('totalSqft')?.value || 300);
    zones = [
        { name:'Main Gym Floor', type:'rubber_roll', sqft:Math.round(sqft*0.45) },
        { name:'Free Weights Area', type:'rubber_tile', sqft:Math.round(sqft*0.20) },
        { name:'Cardio Zone', type:'vinyl', sqft:Math.round(sqft*0.15) },
        { name:'Functional / Turf Lane', type:'turf', sqft:Math.round(sqft*0.10) },
        { name:'Stretch / Class Area', type:'foam', sqft:Math.round(sqft*0.10) },
    ];
    zonesEdited = false;
    renderZones();
}

function addZone() {
    zones.push({ name:'New Zone', type:'rubber_roll', sqft:50 });
    zonesEdited = true;
    renderZones();
}

function removeZone(i) {
    zones.splice(i,1);
    zonesEdited = true;
    renderZones();
    recalc();
}

function renderZones() {
    const list = document.getElementById('zoneList');
    list.innerHTML = zones.map((z,i) => `
        <div class="zone-row">
            <input type="text" value="${z.name}" onchange="zones[${i}].name=this.value; zonesEdited=true;" style="padding:6px 10px; border:1px solid var(--border); border-radius:6px; font-size:14px;">
            <select onchange="zones[${i}].type=this.value; zonesEdited=true; recalc();" style="padding:6px 8px; border:1px solid var(--border); border-radius:6px; font-size:13px;">
                ${FLOORING_TYPES.map(f => `<option value="${f.id}" ${f.id===z.type?'selected':''}>${f.name} (£${f.price.toFixed(2)})</option>`).join('')}
            </select>
            <input type="number" value="${z.sqft}" min="0" step="10" onchange="zones[${i}].sqft=parseInt(this.value)||0; zonesEdited=true; updateZoneAllocation(); recalc();" style="padding:6px 10px; border:1px solid var(--border); border-radius:6px; font-size:14px; text-align:right;">
            <button class="remove-zone" onclick="removeZone(${i})" title="Remove zone">&times;</button>
        </div>
    `).join('');
    updateZoneAllocation();
    recalc();
}

function updateZoneAllocation() {
    const totalGym = parseInt(document.getElementById('totalSqft')?.value || 300);
    const allocated = zones.reduce((s,z) => s + z.sqft, 0);
    const pct = Math.min((allocated / totalGym) * 100, 100);
    const over = allocated > totalGym;
    const under = allocated < totalGym;

    document.getElementById('zoneAllocText').textContent = `${allocated.toLocaleString()} of ${totalGym.toLocaleString()} m²`;
    document.getElementById('zoneAllocText').style.color = over ? '#dc2626' : (allocated === totalGym ? '#16a34a' : 'var(--text)');

    const bar = document.getElementById('zoneAllocBar');
    bar.style.width = Math.min(pct, 100) + '%';
    bar.style.background = over ? '#dc2626' : (allocated === totalGym ? '#16a34a' : 'var(--accent)');

    const warn = document.getElementById('zoneAllocWarn');
    if (over) {
        warn.style.display = 'block';
        warn.style.color = '#dc2626';
        warn.textContent = `⚠ You've allocated ${(allocated - totalGym).toLocaleString()} m² more than your total gym space.`;
    } else if (under) {
        warn.style.display = 'block';
        warn.style.color = 'var(--text-light)';
        warn.textContent = `${(totalGym - allocated).toLocaleString()} m² unallocated — you can add another zone or increase existing ones.`;
    } else {
        warn.style.display = 'block';
        warn.style.color = '#16a34a';
        warn.textContent = '✓ All space allocated.';
    }
}

function getFloorCost() {
    return zones.reduce((sum, z) => {
        const ft = FLOORING_TYPES.find(f => f.id === z.type);
        return sum + (ft ? ft.price * z.sqft : 0);
    }, 0);
}

// ============ STEP 3: EQUIPMENT ============
function renderEquipment() {
    const container = document.getElementById('equipmentList');
    let html = '';
    EQUIPMENT_CATEGORIES.forEach(cat => {
        html += `<h3 style="font-size:15px; margin:16px 0 8px; color:var(--text-light);">${cat.name}</h3>`;
        cat.items.forEach(item => {
            const key = cat.id+'_'+item.name.replace(/\s+/g,'_');
            if(!(key in equipQtys)) equipQtys[key] = item.qty;
            html += `
            <div style="display:grid; grid-template-columns:1fr 100px 100px; gap:10px; align-items:center; padding:8px 0; border-bottom:1px solid var(--border);">
                <span style="font-size:14px;">${item.name}</span>
                <input type="number" min="0" max="50" value="${equipQtys[key]}" data-key="${key}"
                    onchange="equipQtys['${key}']=parseInt(this.value)||0; recalc();"
                    style="padding:6px 10px; border:1px solid var(--border); border-radius:6px; text-align:center; font-size:14px;">
                <span class="equip-line-cost" data-key="${key}" style="text-align:right; font-weight:600; font-size:14px;">£0</span>
            </div>`;
        });
    });
    container.innerHTML = html;
}

function getEquipCost() {
    const tier = document.getElementById('equipTier').value;
    let total = 0;
    EQUIPMENT_CATEGORIES.forEach(cat => {
        cat.items.forEach(item => {
            const key = cat.id+'_'+item.name.replace(/\s+/g,'_');
            const qty = equipQtys[key] ?? item.qty;
            const unitCost = item[tier];
            const line = qty * unitCost;
            total += line;
            const el = document.querySelector(`.equip-line-cost[data-key="${key}"]`);
            if(el) el.textContent = '£'+line.toLocaleString();
        });
    });
    return total;
}

// ============ STEP 4: OTHER COSTS ============
function renderOtherCosts() {
    const container = document.getElementById('otherCostsList');
    let html = '';
    OTHER_COSTS.forEach(c => {
        if(c.calcType==='contingency') return;
        html += `
        <div style="display:grid; grid-template-columns:1fr 140px; gap:10px; align-items:center; padding:10px 0; border-bottom:1px solid var(--border);">
            <span style="font-size:14px;">${c.name}</span>
            <input type="number" id="oc_${c.id}" min="0" step="100"
                onchange="otherOverrides['${c.id}']=parseInt(this.value)||0; recalc();"
                style="padding:6px 10px; border:1px solid var(--border); border-radius:6px; text-align:right; font-size:14px;">
        </div>`;
    });
    container.innerHTML = html;
}

function calcOtherCosts() {
    const sqft = parseInt(document.getElementById('totalSqft').value);
    const loc = document.getElementById('locationTier').value;
    const build = document.getElementById('buildCondition').value;
    const costs = {};

    OTHER_COSTS.forEach(c => {
        if(c.calcType==='contingency') return;
        let val = 0;
        if(c.calcType==='lease') {
            val = Math.round((c.multipliers[loc] * sqft / 12) * 3); // 3 months deposit
        } else if(c.calcType==='buildout') {
            val = Math.round(c.multipliers[build] * sqft);
        } else if(c.calcType==='perSqft') {
            val = Math.round(c.base + c.perSqft * sqft);
        } else if(c.calcType==='flat') {
            val = c.flat[loc];
        } else if(c.calcType==='workingCap') {
            val = c.multipliers[loc] * 3;
        }
        if(c.id in otherOverrides) val = otherOverrides[c.id];
        costs[c.id] = val;
        const el = document.getElementById('oc_'+c.id);
        if(el && !(c.id in otherOverrides)) el.value = val;
    });
    return costs;
}

// ============ RECALC ============
function recalc() {
    const floorCost = getFloorCost();
    const equipCost = getEquipCost();
    const otherCosts = calcOtherCosts();
    const totalOther = Object.values(otherCosts).reduce((a,b)=>a+b,0);
    const sqft = parseInt(document.getElementById('totalSqft').value);
    const totalFloorArea = zones.reduce((s,z)=>s+z.sqft, 0);

    // Update flooring display
    document.getElementById('totalFloorArea').textContent = totalFloorArea.toLocaleString()+' m²';
    const pct = sqft > 0 ? Math.round(totalFloorArea/sqft*100) : 0;
    document.getElementById('floorCoverage').textContent = `(${pct}% of total space)`;
    document.getElementById('totalFloorCost').textContent = '£'+Math.round(floorCost).toLocaleString();

    // Update equipment display
    document.getElementById('totalEquipCost').textContent = '£'+Math.round(equipCost).toLocaleString();

    // Update other costs display
    document.getElementById('totalOtherCost').textContent = '£'+Math.round(totalOther).toLocaleString();
}

// ============ STEP 5: SUMMARY ============
function renderSummary() {
    recalc();
    const sqft = parseInt(document.getElementById('totalSqft').value);
    const memberPrice = parseFloat(document.getElementById('memberPrice').value) || 45;
    const gymName = document.getElementById('gymName').value || 'Your Gym';

    const floorCost = getFloorCost();
    const equipCost = getEquipCost();
    const otherCosts = calcOtherCosts();

    // Build category totals
    const categories = {
        'Flooring': Math.round(floorCost),
        'Equipment': Math.round(equipCost),
    };
    OTHER_COSTS.forEach(c => {
        if(c.calcType==='contingency') return;
        categories[c.name] = otherCosts[c.id];
    });

    const subtotal = Object.values(categories).reduce((a,b)=>a+b,0);
    const contingency = Math.round(subtotal * 0.10);
    categories['Contingency (10%)'] = contingency;
    const grandTotal = subtotal + contingency;

    // KPIs
    document.getElementById('kpiTotal').textContent = '£'+grandTotal.toLocaleString();
    document.getElementById('kpiPerSqft').textContent = '£'+(grandTotal/sqft).toFixed(0);
    const breakeven = Math.ceil(grandTotal / (memberPrice * 0.40 * 12));
    document.getElementById('kpiBreakeven').textContent = breakeven.toLocaleString();
    document.getElementById('kpiFloorPct').textContent = Math.round(floorCost/grandTotal*100)+'%';
    document.getElementById('summaryTitle').textContent = (gymName !== '' ? gymName + ' — ' : '') + 'Budget Summary';

    // Summary list
    const list = document.getElementById('summaryList');
    let html = '';
    Object.entries(categories).forEach(([k,v]) => {
        const isFloor = k === 'Flooring';
        html += `<li class="summary-item ${isFloor?'flooring-highlight':''}">
            <span class="label">${k}</span>
            <span class="value">£${v.toLocaleString()}</span>
        </li>`;
    });
    html += `<li class="summary-item total"><span class="label">Total Startup Cost</span><span class="value">£${grandTotal.toLocaleString()}</span></li>`;
    list.innerHTML = html;

    // Chart
    const labels = Object.keys(categories);
    const data = Object.values(categories);
    const colors = ['#e94560','#0984e3','#fdcb6e','#00b894','#6c5ce7','#e17055','#00cec9','#fab1a0','#74b9ff','#a29bfe','#55efc4','#fd79a8','#636e72'];

    if(budgetChart) budgetChart.destroy();
    budgetChart = new Chart(document.getElementById('budgetChart').getContext('2d'), {
        type:'doughnut',
        data:{
            labels, datasets:[{ data, backgroundColor:colors.slice(0,labels.length), borderColor:'#fff', borderWidth:2 }]
        },
        options:{
            responsive:true, maintainAspectRatio:false, cutout:'55%',
            plugins:{
                legend:{ position:'right', labels:{ font:{size:12}, padding:10, usePointStyle:true }},
                tooltip:{
                    callbacks:{
                        label: ctx => {
                            const total = ctx.dataset.data.reduce((a,b)=>a+b,0);
                            const pct = ((ctx.parsed/total)*100).toFixed(1);
                            return `${ctx.label}: £${ctx.parsed.toLocaleString()} (${pct}%)`;
                        }
                    }
                }
            }
        }
    });

    // Flooring breakdown table
    const ft = document.getElementById('flooringSummaryTable');
    if(zones.length) {
        let thtml = '<table style="width:100%; border-collapse:collapse; font-size:14px;">';
        thtml += '<thead><tr style="border-bottom:2px solid var(--border);"><th style="text-align:left;padding:8px;">Zone</th><th style="text-align:left;padding:8px;">Type</th><th style="text-align:right;padding:8px;">m²</th><th style="text-align:right;padding:8px;">£/m²</th><th style="text-align:right;padding:8px;">Cost</th></tr></thead><tbody>';
        zones.forEach(z => {
            const ftype = FLOORING_TYPES.find(f=>f.id===z.type);
            const cost = ftype ? ftype.price * z.sqft : 0;
            thtml += `<tr style="border-bottom:1px solid var(--border);"><td style="padding:8px;">${z.name}</td><td style="padding:8px;">${ftype?.name||'-'}</td><td style="text-align:right;padding:8px;">${z.sqft.toLocaleString()}</td><td style="text-align:right;padding:8px;">£${ftype?.price.toFixed(2)||'-'}</td><td style="text-align:right;padding:8px;font-weight:700;">£${Math.round(cost).toLocaleString()}</td></tr>`;
        });
        thtml += `<tr style="border-top:2px solid var(--accent);"><td colspan="4" style="padding:8px;font-weight:700;">Total Flooring</td><td style="text-align:right;padding:8px;font-weight:700;color:var(--accent);">£${Math.round(floorCost).toLocaleString()}</td></tr>`;
        thtml += '</tbody></table>';
        ft.innerHTML = thtml;
    }

    renderProjection();
}

// ============ 12-MONTH PROJECTION ============
function renderProjection() {
    const startMembers = parseInt(document.getElementById('projStartMembers').value) || 50;
    const growthPct = parseFloat(document.getElementById('projGrowthRate').value) || 10;
    const opCosts = parseFloat(document.getElementById('projOpCosts').value) || 8000;
    const memberPrice = parseFloat(document.getElementById('memberPrice').value) || 45;

    // Get grand total from the existing summary KPI
    const grandTotalText = document.getElementById('kpiTotal')?.textContent || '£0';
    const grandTotal = parseFloat(grandTotalText.replace(/[£,]/g, '')) || 0;

    // Build month-by-month data
    const months = [];
    let cumPL = -grandTotal; // start in the red by the full startup cost
    let breakEvenMonth = null;

    for (let m = 1; m <= 36; m++) {
        const members = Math.round(startMembers * Math.pow(1 + growthPct / 100, m - 1));
        const revenue = members * memberPrice;
        const profit = revenue - opCosts;
        cumPL += profit;
        if (breakEvenMonth === null && cumPL >= 0) breakEvenMonth = m;
        months.push({ month: m, members, revenue, opCosts, profit, cumPL });
    }

    const last = months[months.length - 1];
    const totalRevenue = months.reduce((s, r) => s + r.revenue, 0);

    // KPIs
    const kpiWrap = document.getElementById('projectionKpis');
    kpiWrap.innerHTML = `
        <div style="background:var(--bg); border-radius:10px; padding:14px; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:${breakEvenMonth ? 'var(--accent)' : '#e17055'};">${breakEvenMonth ? 'Month ' + breakEvenMonth : 'Not in 3 Years'}</div>
            <div style="font-size:12px; color:var(--text-light);">Break-Even Point</div>
        </div>
        <div style="background:var(--bg); border-radius:10px; padding:14px; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:var(--accent);">${last.members.toLocaleString()}</div>
            <div style="font-size:12px; color:var(--text-light);">Members at Month 36</div>
        </div>
        <div style="background:var(--bg); border-radius:10px; padding:14px; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:var(--accent);">£${totalRevenue.toLocaleString()}</div>
            <div style="font-size:12px; color:var(--text-light);">Total 3-Year Revenue</div>
        </div>
        <div style="background:var(--bg); border-radius:10px; padding:14px; text-align:center;">
            <div style="font-size:22px; font-weight:800; color:${last.cumPL >= 0 ? '#00b894' : '#e17055'};">£${last.cumPL.toLocaleString()}</div>
            <div style="font-size:12px; color:var(--text-light);">Net Position at Month 36</div>
        </div>
    `;

    // Chart
    const labels = months.map(r => 'M' + r.month);
    const revenueData = months.map(r => r.revenue);
    const opData = months.map(r => r.opCosts);
    const cumData = months.map(r => r.cumPL);

    if (projectionChart) projectionChart.destroy();
    projectionChart = new Chart(document.getElementById('projectionChartCanvas').getContext('2d'), {
        type: 'line',
        data: {
            labels,
            datasets: [
                { label: 'Monthly Revenue', data: revenueData, borderColor: '#00b894', backgroundColor: 'rgba(0,184,148,0.08)', fill: true, tension: 0.3, pointRadius: 4, borderWidth: 2 },
                { label: 'Operating Costs', data: opData, borderColor: '#e17055', borderDash: [6, 3], fill: false, tension: 0, pointRadius: 3, borderWidth: 2 },
                { label: 'Cumulative P&L', data: cumData, borderColor: '#0984e3', backgroundColor: 'rgba(9,132,227,0.06)', fill: true, tension: 0.3, pointRadius: 4, borderWidth: 2, yAxisID: 'y1' }
            ]
        },
        options: {
            responsive: true, maintainAspectRatio: false,
            interaction: { mode: 'index', intersect: false },
            scales: {
                y: { title: { display: true, text: '£ / Month' }, ticks: { callback: v => '£' + v.toLocaleString() } },
                y1: { position: 'right', title: { display: true, text: 'Cumulative P&L' }, ticks: { callback: v => '£' + v.toLocaleString() }, grid: { drawOnChartArea: false } }
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        label: ctx => ctx.dataset.label + ': £' + ctx.parsed.y.toLocaleString()
                    }
                },
                legend: { labels: { usePointStyle: true, font: { size: 12 } } }
            }
        }
    });

    // Table
    const tw = document.getElementById('projectionTableWrap');
    let t = '<table style="width:100%; border-collapse:collapse; font-size:13px; min-width:580px;">';
    t += '<thead><tr style="border-bottom:2px solid var(--border); background:var(--bg);">';
    t += '<th style="padding:8px; text-align:left;">Month</th>';
    t += '<th style="padding:8px; text-align:right;">Members</th>';
    t += '<th style="padding:8px; text-align:right;">Revenue</th>';
    t += '<th style="padding:8px; text-align:right;">Op. Costs</th>';
    t += '<th style="padding:8px; text-align:right;">Monthly P&L</th>';
    t += '<th style="padding:8px; text-align:right;">Cumulative P&L</th>';
    t += '</tr></thead><tbody>';
    months.forEach(r => {
        const isBE = r.month === breakEvenMonth;
        const rowStyle = isBE ? 'background:rgba(0,184,148,0.08); font-weight:700;' : '';
        t += `<tr style="border-bottom:1px solid var(--border); ${rowStyle}">`;
        t += `<td style="padding:8px;">${isBE ? '⭐ ' : ''}Month ${r.month}</td>`;
        t += `<td style="padding:8px; text-align:right;">${r.members.toLocaleString()}</td>`;
        t += `<td style="padding:8px; text-align:right;">£${r.revenue.toLocaleString()}</td>`;
        t += `<td style="padding:8px; text-align:right;">£${r.opCosts.toLocaleString()}</td>`;
        t += `<td style="padding:8px; text-align:right; color:${r.profit >= 0 ? '#00b894' : '#e17055'};">£${r.profit.toLocaleString()}</td>`;
        t += `<td style="padding:8px; text-align:right; color:${r.cumPL >= 0 ? '#00b894' : '#e17055'}; font-weight:600;">£${r.cumPL.toLocaleString()}</td>`;
        t += '</tr>';
    });
    t += '</tbody></table>';
    tw.innerHTML = t;
}

// ============ EMAIL GATE ============
function unlockGate() {
    const name = document.getElementById('gateName').value.trim();
    const email = document.getElementById('gateEmail').value.trim();
    const errEl = document.getElementById('gateError');

    if (!name || !email) {
        errEl.textContent = 'Please enter your name and email.';
        errEl.style.display = 'block';
        return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errEl.textContent = 'Please enter a valid email address.';
        errEl.style.display = 'block';
        return;
    }

    errEl.style.display = 'none';

    // Build lead payload with gym data
    const payload = {
        name,
        email,
        gymName: document.getElementById('gymName').value,
        totalSpace: document.getElementById('totalSqft').value + ' m²',
        estimatedBudget: document.getElementById('kpiTotal')?.textContent || '',
        source: 'gym-budget-planner-gate',
        timestamp: new Date().toISOString(),
    };

    // ── Send to Formspree ──────────────────────────────────
    // const FORMSPREE_URL = 'https://formspree.io/f/maqdkkze';

    // fetch(FORMSPREE_URL, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    //     body: JSON.stringify(payload),
    // }).then(r => {
    //     if (!r.ok) console.warn('Formspree submission failed:', r.status);
    // }).catch(err => {
    //     console.warn('Formspree error (gate still unlocks):', err);
    // });
    // ───────────────────────────────────────────────────────



    var listPayload = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: payload.email,
                    first_name: payload.name.split(" ")[0],
                    last_name: payload.name.split(" ").slice(1).join(" "),
                    phone_number: payload.phone
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: LIST_ID
                }
              }
            }
          }
        };

        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_PUBLIC_KEY, {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify(listPayload)
        });




    // Unlock the gated content
    document.getElementById('gateWrapper').classList.remove('locked');
    gateUnlocked = true;

    // Pre-fill the bottom CTA form so they don't have to type again
    const leadName = document.getElementById('leadName');
    const leadEmail = document.getElementById('leadEmail');
    if (leadName) leadName.value = name;
    if (leadEmail) leadEmail.value = email;
    submitLead();
}

// ============ LEAD CAPTURE ============
function submitLead() {
    const name = document.getElementById('leadName').value.trim();
    const email = document.getElementById('leadEmail').value.trim();
    const msg = document.getElementById('leadMsg');

    if(!name || !email) {
        msg.style.display = 'block';
        msg.style.color = '#e17055';
        msg.textContent = 'Please enter your name and email.';
        return;
    }
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msg.style.display = 'block';
        msg.style.color = '#e17055';
        msg.textContent = 'Please enter a valid email address.';
        return;
    }

         // In production, replace this with your form endpoint (e.g. Zapier, HubSpot, etc.)
        const lead = {
                name,
                email,
                phone: document.getElementById('leadPhone').value.trim(),
                gymName: document.getElementById('gymName').value,
                sqft: document.getElementById('totalSqft').value,
                floorCost: getFloorCost(),
                totalBudget: '(see summary)',
                zones: zones.map(z => ({...z, typeName: FLOORING_TYPES.find(f=>f.id===z.type)?.name})),
                timestamp: new Date().toISOString(),
            };
            console.log('LEAD CAPTURED:', JSON.stringify(lead, null, 2));

            // const zonesSummary = lead.zones.map(z =>
            // `${z.name} | ${z.typeName} | ${z.sqft} sqft`
            // ).join('\n');
            const zonesSummary = lead.zones.map(z =>
            `${z.name} | ${z.typeName} | ${z.sqft} sqft`
            ).join('<br>');

            var eventPayload = {
            data: {
            type: "event",
            attributes: {
              metric: {
                data: {
                  type: "metric",
                  attributes: {
                    name: "Gym Planner Lead Captured"
                  }
                }
              },
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: lead.email
                  }
                }
              },
              properties: {
                name: lead.name,
                gym_name: lead.gymName,
                total_sqft: lead.sqft,
                flooring_cost: lead.floorCost,
                total_budget: lead.totalBudget,
                zones: zonesSummary,
                source: "Gym Startup Budget Planner"
              }
            }
          }
        };

fetch("https://a.klaviyo.com/client/events/?company_id=" + KLAVIYO_PUBLIC_KEY, {
  method: "POST",
  headers: {
    "Content-Type": "application/vnd.api+json",
    "Accept": "application/vnd.api+json",
    "revision": "2024-10-15"
  },
  body: JSON.stringify(eventPayload)
});


    msg.style.display = 'block';
    msg.style.color = '#00b894';
    msg.textContent = '✓ Thanks, '+name+'! We\'ll be in touch within 24 hours with your custom flooring quote.';
}

// ============ BOOT ============
init();


importChart();

function importChart(){
  const s = document.createElement('script');
  s.src = "https://cdn.jsdelivr.net/npm/chart.js@4.5.1";  
  document.head.appendChild(s);
}
importChart();